export default __webpack_public_path__ + "static/color-picker-agnostic-color-light-c0ceead20d9577fe1a3eb6235dc3ad00.png";